import { numericUtil } from '@cmg/common';
import { createValueFormatter } from '@cmg/data-grid';
import defaultTo from 'lodash/defaultTo';

import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';

export type Value = NonNullable<CalendarGridRowData['attributes']>['priceRangeLow'];

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ data, value }) => {
    const pricingCurrency = defaultTo(data?.attributes?.pricingCurrency, 'USD');

    return numericUtil.getDisplayValueForCurrency(value, 2, pricingCurrency);
  },
});

const priceRangeLowColDef: CalendarGridColDef<Value> = {
  field: 'attributes.priceRangeLow',
  headerName: 'Price Range Low',
  width: 150,
  valueFormatter,
};

export default priceRangeLowColDef;
